import styled from 'styled-components';

const HouseSmartTopStyles = styled.section`
  position: relative;
  .video-embed-wrap {
    width: 95vw;
    max-width: 900px;
  }
  &:after {
    content: '';
    height: 324px;
    background: #0075c9;
    width: 100%;
    position: absolute;
    top: 0;
    display: none;
    @media only screen and (max-width: 1275px) {
      display: flex;
    }
    @media only screen and (max-width: 543px) {
      height: 52vw;
      max-height: 324px;
    }
  }
  .container {
    position: relative;
    max-width: 1215px;
    margin: 0 auto;
    display: flex;
    padding: 150px 0px 135px;
    z-index: 3;
    flex-wrap: wrap;
    @media only screen and (max-width: 1275px) {
      flex-direction: column;
      padding: 75px 25px 100px;
    }
    @media only screen and (max-width: 500px) {
      flex-direction: column;
      padding: 40px 25px 100px;
    }
  }
  .content {
    position: relative;
    flex: 1 47%;
    display: flex;
    flex-direction: column;
    @media only screen and (max-width: 1275px) {
      flex: 1 50%;
      order: 2;
    }
    .content-inner {
      max-width: 432px;
      margin: 0 auto;
      @media only screen and (max-width: 1275px) {
        max-width: 513px;
        align-items: center;
        display: flex;
        flex-direction: column;
      }
    }
    .help-text {
      display: flex;
      align-items: center;
      margin-top: 155px;
      @media only screen and (max-width: 1275px) {
        display: none;
      }
    }
    img {
      margin-bottom: 30px;
      margin-top: -20px;
      width: 432px;
      @media only screen and (max-width: 1275px) {
        max-width: 263px;
        margin-top: 50px;
      }
      @media only screen and (max-width: 500px) {
        max-width: 231px;
      }
    }
    .introduction {
      max-width: 400px;
      @media only screen and (max-width: 1275px) {
        max-width: 100%;
      }
    }
  }
  .video-box {
    position: relative;
    width: 600px;
    max-width: 600px;
    height: 400px;
    flex: 0 53%;
    cursor: pointer;
    @media only screen and (max-width: 1275px) {
      flex: 1 100%;
      order: 1;
      margin: 0 auto;
      width: 100%;
      max-width: 510px;
    }
    span,
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    #playBtn {
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      transform: translateY(20px);
      position: absolute;
      width: 110px;
    }
  }
  .shape {
    position: absolute;
    right: 0;
    top: 0;
    @media only screen and (max-width: 1275px) {
      display: none;
    }
  }
  .quick-links {
    position: relative;
    width: 100%;
    @media only screen and (max-width: 1275px) {
      display: none;
    }
    ul {
      display: flex;
      justify-content: space-between;
      list-style: none;
      margin-top: 40px;
      li {
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
`;

export default HouseSmartTopStyles;
